// Harta e imazheve të produkteve.
// Zëvendëso çdo PNG me foton reale të produktit (pa sfond, PNG transparent).
// Çelësi duhet të përputhet me "slug" te src/data/products.json.

import sleep from "./sleep.jpg";
import focus from "./focus.jpg";
import energy from "./energy.jpg";
import calm from "./calm.jpg";
import relax from "./relax.jpg";
import breathe from "./breathe.jpg";
import nausea from "./nausea.jpg";
import slim from "./slim.webp";

const images = { sleep, focus, energy, calm, relax, breathe, nausea, slim };

export default images;
